module.exports = __webpack_public_path__ + "img/steel-3.7ad58339.jpg";